import ChipFilter from "./ChipFilter";
import DateRangeFilter from "./DateRangeFilter";
import ListFilter from "./ListFilter";
import NumericRangeFilter from "./NumericRangeFilter";
import { FilterSelectionType, FilterStateType, TableFilterAction } from "./models";

type RenderFilterOptions = {
	isTabsGroup?: boolean;
	usePopover: boolean;
	dispatcher: (action: TableFilterAction) => void;
	customOnSelectAction?: () => void;
	handlePopoverClose?: () => void;
};

export function renderFilterComponent(filter: FilterStateType, options: RenderFilterOptions) {
	switch (filter.selectionType) {
		case FilterSelectionType.DATE_RANGE:
			return <DateRangeFilter filter={filter} usePopover={options.usePopover} dispatcher={options.dispatcher} />;
			case FilterSelectionType.NUMERIC_RANGE:
				return <NumericRangeFilter filter={filter} usePopover={options.usePopover} dispatcher={options.dispatcher} />;
				case FilterSelectionType.LIST:
			return (
				<ListFilter
					filter={filter}
					usePopover={options.usePopover}
					dispatcher={options.dispatcher}
					customOnSelectAction={options.customOnSelectAction}
					handlePopoverClose={options.handlePopoverClose}
					isTabsGroup={options.isTabsGroup}
				/>
			);
		case FilterSelectionType.CHIP:
			return <ChipFilter filter={filter} dispatcher={options.dispatcher} />;
		default:
			throw new Error(`Unknown selectionType: ${(filter as FilterStateType).selectionType}`);
	}
}